import { html, css } from '~/lib/bn-lit-element';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-loading';

export const IntegrationOverviewMixin = (superClass) => class extends superClass {
  static get properties() {
    return {
      showModal: { type: Boolean, attribute: false },
      integrationEnabled: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .container {
        line-height: 38px;
      }
      .title {
        font-weight: bold;
      }
      .status {
        margin-left: 10px;
        padding: 2px 12px;
        font-size: smaller;
        font-weight: 900;
        color: var(--white-base);
      }
      .enabled {
        background-color: var(--green-15);
      }
      .disabled {
        background-color: var(--gray-50);
      }
      .button {
        float: right;
      }
    `];
  }

  renderOverview() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }

    if (!this.entity) {
      return html``;
    }

    return html`
      <div class="container">
        <span class="title">${this.title}</span>
        ${this.integrationEnabled ? html`
          <span class="status enabled">Enabled</span>
        ` : html`
          <span class="status disabled">Disabled</span>
        `}
        <button class="button button--contained" @click="${this._configure}">Configure</button>
      </div>

      ${this.renderModal()}
    `;
  }

  _configure(e) {
    e.stopPropagation();
    this.showModal = true;
  }

  // Override this method to render modal
  renderModal() {
    return html``;
  }
};
